import { render, staticRenderFns } from "./Afkir.vue?vue&type=template&id=967e886c&"
import script from "./Afkir.vue?vue&type=script&lang=js&"
export * from "./Afkir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports